<template>
  <button class="base-button">
    <img :src="iconSrc" :alt="type" class="icon" />
  </button>
</template>

<script lang="ts">
import { defineComponent, computed } from "vue";

export default defineComponent({
  name: "TableIcon",
  props: {
    type: {
      type: String as () =>
        | "Delete"
        | "Edit"
        | "SelectFile"
        | "UploadFile"
        | "Images"
        | "Receipt"
        | "Cancel",
      required: true,
    },
  },
  setup(props) {
    const iconMap: Record<string, string> = {
      Delete: require("@/assets/icons/Delete.svg"),
      Edit: require("@/assets/icons/Edit.svg"),
      SelectFile: require("@/assets/icons/ExcelFile.svg"),
      UploadFile: require("@/assets/icons/UploadFile.svg"),
      Images: require("@/assets/icons/Images.svg"),
      Receipt: require("@/assets/icons/Receipt.svg"),
      Cancel: require("@/assets/icons/Cancel.svg"),
    };

    const iconSrc = computed(() => iconMap[props.type]);

    return { iconSrc };
  },
});
</script>


<style scoped lang="scss">
@import "src/styles/commons/controls/tableButton";
</style>
